export default "__VITE_ASSET__3bc52617__"